import React from 'react';
import { Accessor, DatumId } from '../core/Chart.types';
import { isDefaultIdAccessor } from './defaultGetIdentifier';
import { isLocalizedObject, localizeObject } from './localizeObject';

export const useEnsureDatumIdentifier = <Datum>(data: Datum[], idAccessor: Accessor<Datum, DatumId>) =>
  React.useMemo(
    () => (!isDefaultIdAccessor(idAccessor) ? data : data.map(datum => (isLocalizedObject(datum) ? datum : localizeObject(datum)))),
    [data, idAccessor]
  );
